export default {
    api: {
        // baseUrl: 'http://localhost:3001/api/v1',
        // baseUrl: 'http://testing.api.virtu.thinmartian.com/api/v1',
        // baseUrl: 'https://underwriter.virtusolutions.co.UK/api/v1',
        // baseUrl: 'https://staging.api.axa.thinmartian.com/api/v1',
        baseUrl: 'https://staging.api.virtu.thinmartian.com/api/v1',
    },
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config/base.ts